<template>
  <div v-if="item" class="summaryItem">
    <!-- 어메니티 -->
    <div v-if="item.submitId.includes('system_amenity')" class="itemInfo">
      <div class="subject notranslate toCapitalize">{{locale.amenity}}</div>
    </div>
    <!-- //어메니티 -->
    <!-- 페이지, 상품 -->
    <div v-else class="itemInfo">
      <div v-if="item.info.thumbnail && item.info.thumbnail !== ''" class="thumb">
        <img :src="item.info.thumbnail" alt="">
      </div>
      <div class="subject">
        {{item.info.subject[lang]}}
        <span v-if="item.price.info && item.price.info.price">({{priceFormat(item.price.info.price)}})</span>
        <p v-if="item.place" class="place"> ({{locale.place}}: {{item.place[lang]}})</p>
      </div>
    </div>
    <div class="itemOption">
      <div v-if="item.submitId.includes('system_amenity')" class="optionInfo amenityInfo">
        <div class="list">
          <!-- 어메니티 -->
          <div v-for="amenity in amenityList"
            :key="amenity.item"
            class="item notranslate">
            <div class="label">
              <img :src="src(amenity.item)" alt="" />
              {{amenity.label
                ? amenity.label[$route.params.ln]
                : localeAmenity[`amenity_${amenity.item.toLowerCase()}`]}}
              <span v-if="amenity.price">({{priceFormat(amenity.price)}})</span>
               * {{amenity.count}}
            </div>
            <div v-if="amenity.price" class="value">
              {{priceFormat(amenity.price * amenity.count)}}
            </div>
          </div>
          <!-- //어메니티 -->
        </div>
      </div>
      <!-- options -->
      <div v-if="options.length || itemDatetime" class="optionInfo">
        <div class="list">
          <div v-for="(order, index) in options"
            :key="index"
            class="item">
            <div v-if="order.type === 'checkbox'">
              <span class="label">{{order.label[lang]}}</span>
              <div class="value">
                <span
                  v-for="(option, index) in displayValue(order)"
                  :key="index"
                  class="valueArr">
                  {{option}}
                </span>
              </div>
            </div>
            <div v-else-if="order.type === 'signaturepad'">
              <span class="label">{{order.label[lang]}}</span>
              <div class="value notranslate">
                <img :src="order.value" alt="" />
              </div>
            </div>
            <div v-else-if="order.type === 'cert'">
              <span class="label">{{order.label[lang]}}</span>
              <div class="value notranslate">
                <div>{{locale.name}}: {{order.value.name}}</div>
                <div>{{locale.telephone}}: {{order.value.phone}}</div>
                <div>{{locale.birthdate}}: {{order.value.birthDate}}</div>
              </div>
            </div>
            <div v-else-if="order.type === 'uploadImage'">
              <div v-for="img in order.value"
                :key="img.id"
                class="mt10">
                <span class="label">{{order.label[lang]}}</span>
                <div class="value notranslate">
                  <span v-if="img.previewType === 'filename'">🖺 {{img.name}}</span>
                  <img v-else :src="img.path" class="mt5" alt="">
                </div>
              </div>
            </div>
            <div v-else>
              <span class="label">{{order.label[lang]}}</span>
              <div class="value"
                :class="{notranslate: order.type === 'rate'}">
                {{displayValue(order)}}
              </div>
            </div>
          </div>
          <!-- datetime -->
          <div v-if="itemDatetime" class="item notranslate toCapitalize">
            <span class="label">{{locale.datetime}}</span>
            <div class="value">{{requestTime}}</div>
          </div>
          <!-- //datetime -->
        </div>
      </div>
      <!-- //options -->
      <!-- 고객식별타입 -->
      <div v-if="item.guestTypePrice && isGuestDiscount" class="optionInfo">
        <div class="item">
          <div class="label">
            {{item.guestTypePrice.name[lang]}}<span v-if="item.guestTypePrice.discountPrice"> ({{item.guestTypePrice.priceDiscount}})</span>
          </div>
          <div class="value notranslate">{{priceFormat(item.guestTypePrice.discountPrice) || item.guestTypePrice.priceDiscount}}</div>
        </div>
      </div>
      <!-- //고객식별타입 -->
      <!-- coupon -->
      <div v-if="item.useCoupon && item.useCoupon.useCoupon" class="optionInfo">
        <div class="list">
          <div v-for="(coupon, index) in item.useCoupon.useCoupon"
            :key="index"
            class="item"
            :class="{interSection: couponIntersection(coupon.cid)}">
            <div>
              <div class="label">
                ({{locale.coupon}}) {{coupon.payload.text1[lang] || coupon.payload.text2[lang] || coupon.title}}
                <span v-if="couponIntersection(coupon.cid)">
                  ({{getCouponValue(coupon.payload)}} * {{couponIntersection(coupon.cid).qty}})
                </span>
              </div>
              <div class="value notranslate">
                <span v-if="couponIntersection(coupon.cid)">
                  {{getCouponValue(coupon.payload, couponIntersection(coupon.cid).qty)}}
                </span>
                <span v-else>
                  {{getCouponValue(coupon.payload)}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- //coupon -->
      <div v-if="item.price.info && item.price.info.quantity" class="priceInfo notranslate toCapitalize">
        <span class="label">{{locale.quantity}}</span>
        <span class="value">{{item.price.info.quantity}}</span>
      </div>
      <!-- discount -->
      <div v-if="item.price.info && item.price.info.discount" class="priceInfo notranslate toCapitalize">
        <span class="label">{{locale.discount}}</span>
        <span class="value">-{{priceFormat(item.price.info.discount)}}</span>
      </div>
      <!-- //discount -->
      <!-- total price -->
      <div v-if="item.price.info && item.price.info.total !== 0" class="priceInfo notranslate toCapitalize">
        <span class="label">{{locale.total}}</span>
        <span class="value">{{priceFormat(item.price.info.tax ? item.price.info.subtotal : item.price.info.total)}}</span>
      </div>
      <!-- //total price -->
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import { DateTime } from 'luxon'
import moment from 'moment/moment'

export default {
  name: 'SummaryItem',
  props: [
    'lang',
    'locale',
    'localeAmenity',
    'item'
  ],
  computed: {
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    isGuestDiscount () {
      return this.item.guestTypePrice && this.item.guestTypePrice.normalPrice !== this.item.guestTypePrice.total
    },
    options () {
      const content = this.item.content && !this.item.submitId.includes('system_amenity')
        ? this.item.content.filter(x => x.type !== 'datetime' && x.type !== 'quantity').map(x => {
          return {
            ...x,
            label: x.displayLabel || x.label,
            value: x.valueOption || x.value
          }
        })
        : []
      content.forEach(function (x) {
        if (x.valueOption) {
          delete x['valueOption']
        }
        if (x.valueIndex) {
          delete x['valueIndex']
        }
      })
      return content || []
    },
    itemDatetime () {
      return this.item.content ? this.item.content.find(x => x.type === 'datetime') : null
    },
    amenityList () {
      return this.item.items && this.item.items.filter(x => x.price && x.price > 0)
    },
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    priceOption () {
      const lang = this.lang
      let option = []
      this.options.forEach(function (x) {
        if (x.value) {
          if (x.type === 'checkbox') {
            option = option.concat(x.value.filter(o => o.price && o.price.length).map(function (oo) {
              return {
                label: oo.label[lang],
                price: oo.quantity ? oo.price * oo.quantity : oo.price,
                ...oo.quantity && {
                  quantity: oo.quantity
                }
              }
            }))
          } else if (x.value.price) {
            option = option.concat({
              label: x.value.label[lang],
              price: x.value.quantity ? x.value.price * x.value.quantity : x.value.price,
              ...x.value.quantity && {
                quantity: x.value.quantity
              }
            })
          }
        }
      })
      return option
    },
    dateFormat () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      return date
    },
    format () {
      const time = 'HH:mm'
      return `${this.dateFormat} ${time}`
    },
    requestTime () {
      const settime = this.itemDatetime ? DateTime.fromISO(this.itemDatetime.value.settime, { zone: this.timezone }) : null
      const requestTime = this.itemDatetime
        ? this.itemDatetime.value.type === 'asap' ? this.locale.datetime_asap : settime.toFormat(this.format)
        : null
      return requestTime
    },
    itemInfo () {
      const isPage = !!this.item.pageId && this.item.pageId !== null
      const isProduct = !!this.item.productId && this.item.productId !== null
      return {
        isPage: isPage,
        isProduct: isProduct,
        routeName: isPage ? 'page' : isProduct ? 'product' : null,
        routeParams: {
          id: isPage ? this.item.pageId : isProduct ? this.item.productId : null
        }
      }
    }
  },
  methods: {
    src (amenityItem) {
      return `${process.env.BASE_URL}img/amenity/${amenityItem.toLowerCase()}.png`
    },
    displayValue (order) {
      const lang = this.lang
      let value = order.value
      switch (order.type) {
        case 'rate':
          value = `${value.value} / ${value.max}`
          break
        case 'radio':
          value = value.label[lang] + (value.price ? ` (${this.priceFormat(value.price)})` : '') + (value.quantity ? `  * ${value.quantity}` : '')
          break
        case 'checkbox':
          value = value.map(x => {
            const label = x.label[lang]
            const price = x.price ? `(${this.priceFormat(x.price)})` : ''
            const quantity = x.quantity ? ` * ${x.quantity}` : ''
            return `${label} ${price} ${quantity}`
          })
          break
        case 'select':
          value = value.label[lang] + (value.price ? ` (${this.priceFormat(value.price)})` : '')
          break
        case 'calendar':
          value = DateTime.fromISO(value).toFormat(this.dateFormat)
          break
      }
      return value
    },
    displayPrice (price) {
      const currency = this.$store.state.common.setting.currencyEntity
      return `${currency} ${regExp.comma(price)}`
    },
    priceFormat (price) {
      const code = this.currencyCode
      return regExp.priceFormat(price, code)
    },
    getCouponValue (coupon, qty) {
      let result = ''
      function discountRate (total, rate) { // 할인율 적용된 금액
        const totalPrice = total && parseFloat(total) > 0
        return totalPrice ? parseFloat(total) * parseFloat(rate) / 100 : null
      }
      if (coupon && coupon.discount) {
        const discountType = coupon.discountType
        const value = coupon.discountValue
        const total = this.item.useCoupon && this.item.useCoupon.couponPrice && this.item.useCoupon.couponPrice.normalPrice
        switch (discountType) {
          case 'price':
            result = this.priceFormat(value * (qty ? parseInt(qty) : 1))
            break
          case 'rate':
            result = discountRate(total, value)
              ? `${this.priceFormat(discountRate(total, value))}` // ${value}%
              : ''
            break
        }
        result = `-${result}`
      }
      return result
    },
    couponIntersection (cid) {
      const coupon = this.item.useCoupon && this.item.useCoupon.useCoupon && this.item.useCoupon.useCoupon.filter(x => x.cid === cid && x.payload.allowedQty)
      return coupon && coupon.length ? {
        qty: coupon.length,
        ...coupon[0].payload.discount && coupon[0].payload.discountValue && {
          discountValue: parseInt(coupon[0].payload.discountValue) * coupon.length
        }
      } : null
    }
  }
}
</script>
